import "../src/modernizr"; // 'npm run modernizr' to create this file
